(function () {
  var scope = document.getElementById('hb-faq-page-scope');
  if (!scope) return;

  var searchInput = document.getElementById('hb-faq-page-search-input');
  var chipsWrap = document.getElementById('hb-faq-page-chips');
  var groupsWrap = document.getElementById('hb-faq-page-groups');
  var noResults = document.getElementById('hb-faq-page-no-results');
  var items = Array.prototype.slice.call(scope.querySelectorAll('[data-hb-faq-page-item]'));
  var groups = Array.prototype.slice.call(scope.querySelectorAll('[data-hb-faq-page-group]'));
  var chips = chipsWrap ? Array.prototype.slice.call(chipsWrap.querySelectorAll('[data-hb-faq-page-chip]')) : [];

  function normalize(text) {
    return text
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '');
  }

  var activeCategory = 'kaikki';

  function applyFilters() {
    var term = normalize(searchInput ? searchInput.value.trim() : '');
    var anyVisible = false;

    items.forEach(function (item) {
      var matchesCategory = activeCategory === 'kaikki' || item.getAttribute('data-category') === activeCategory;
      var text = normalize(item.textContent);
      var matchesSearch = term === '' || text.indexOf(term) !== -1;
      var visible = matchesCategory && matchesSearch;

      item.hidden = !visible;
      if (visible) anyVisible = true;
    });

    groups.forEach(function (group) {
      var visibleItems = group.querySelectorAll('[data-hb-faq-page-item]:not([hidden])');
      group.hidden = visibleItems.length === 0;
    });

    if (noResults) {
      noResults.hidden = anyVisible;
      noResults.classList.toggle('is-visible', !anyVisible);
    }
  }

  function setCategory(category, updateUrl) {
    activeCategory = category;

    chips.forEach(function (chip) {
      chip.classList.toggle('is-active', chip.getAttribute('data-category') === category);
    });

    if (updateUrl) {
      var url = new URL(window.location.href);
      if (category === 'kaikki') {
        url.searchParams.delete('kategoria');
      } else {
        url.searchParams.set('kategoria', category);
      }
      window.history.replaceState(null, '', url);
    }

    applyFilters();
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      setCategory(chip.getAttribute('data-category'), true);
    });
  });

  if (searchInput) {
    searchInput.addEventListener('input', applyFilters);
  }

  var initialCategory = new URLSearchParams(window.location.search).get('kategoria') || 'kaikki';
  setCategory(initialCategory, false);

  /* ---------------- Deep link: open + scroll to a linked question ---------------- */

  function openFromHash() {
    var hash = window.location.hash;
    if (!hash) return;
    var target = document.getElementById(hash.slice(1));
    if (!target || !target.hasAttribute('data-hb-faq-page-item')) return;

    if (target.hidden) {
      setCategory('kaikki', true);
    }
    target.open = true;
    target.scrollIntoView({ block: 'start' });
  }

  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  /* ---------------- Analytics: track which questions get opened ---------------- */

  items.forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (!item.open) return;
      var question = item.querySelector('.hb-faq-page__item-summary span');
      document.dispatchEvent(
        new CustomEvent('hb:faq-opened', {
          detail: { id: item.id, question: question ? question.textContent : '' }
        })
      );
    });
  });
})();
